// Libs
import ApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useEffect, useState } from "react";
// Types
import { ChartSetFive } from "../Libs/Types/ChartTypes";
// Utils
import {
  CHART_AXIS_FALLBACK,
  chartColors,
  chartHeight,
} from "../Libs/Utils/utils";
// UI-Components
import ChartFallBack from "../UI-Components/ChartFallback";

export default function FunnelChart({
  chartData,
  dataKey,
}: {
  chartData: ChartSetFive["FunnelChart"];
  dataKey: string;
}) {
  const [, falseState] = useState<ChartSetFive["FunnelChart"]["data"]>();
  const option: ApexOptions = {
    chart: {
      fontFamily: "Poppins",
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
      dropShadow: {
        enabled: true,
      },
    },
    dataLabels: {
      style: {
        fontSize: "8px",
      },
    },
    legend: {
      show: false,
    },
    title: {
      style: { fontSize: "14px", fontWeight: "900" },
      text:
        chartData !== undefined
          ? chartData["title"]
          : CHART_AXIS_FALLBACK["title"],
      align: "left",
    },
    colors: chartColors,
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
        distributed: true,
        barHeight: "80%",
        isFunnel: true,
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "horizontal",
        shadeIntensity: 0.1,
        gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 25, 50, 75, 100],
        colorStops: [],
      },
    },
    xaxis: {
      labels: {
        style: {
          fontSize: "8px",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "8px",
        },
        show: true,
      },
    },
  };

  const series: any =
    chartData !== undefined && Array.isArray(chartData["data"]) === true
      ? chartData["data"]
      : undefined;

  useEffect(() => {
    falseState(chartData["data"]);
  }, [chartData]);
  return (
    <div className="my-2 chartWrp border-1 rounded-lg w-full p-2">
      {series !== undefined ? (
        <ApexChart
          type="bar"
          options={option}
          series={series}
          height={chartHeight}
          width={"100%"}
          key={dataKey}
        />
      ) : (
        <ChartFallBack />
      )}
    </div>
  );
}
